export default __webpack_public_path__ + "img/01bd978afa370f7f6b72abb4ac62c629.png";